module.exports = __webpack_public_path__ + "static/media/tabla.4461c8f9.svg";